import { nameRegex } from '../../../config/form/regex';
import yup from '../../../config/yup';

export const amazonRDSReaderFormSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(nameRegex, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('amazonRDSReader'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  parameterizedBy: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    databaseType: yup
      .string()
      .required('Database type is required')
      .matches(/^(PostgreSQL|MySQL|\{\{env\.vars\.[a-zA-Z0-9_]+\}\})$/, {
        message:
          'Database type must be PostgreSQL, MySQL or an environment variable pattern {{env.vars.*}}',
      })
      .default('PostgreSQL'),
    databaseName: yup
      .string()
      .required('Database name is required')
      .transform((value) => value.trim()),
    username: yup.string().transform((value) => value?.trim()),
    password: yup.string().transform((value) => value?.trim()),
    instanceConnectionName: yup.string().transform((value) => value?.trim()),
    // JDBC properties
    driver: yup.string().required('Driver is required'),
    sqlQuery: yup
      .string()
      .required('SQL Query is required')
      .transform((value) => value.trim()),
    host: yup.string().required('Host is required'),
    port: yup.number().typeError('Port must be a number'),
  }),
});
